<template>
<div class="mt-4 space-y-4">
  <button type="button" @click="back" class="flex items-center space-x-0.5 text-gray-600">
    <ChevronLeftIcon class="w-5 h-5 text-gray-500" />
    <span>Back</span>
  </button>

  <p class="prose prose-sm prose-blue">
    Please read through our <a @click="showRequirements" class="cursor-pointer">requirements</a> to check you meet our requirements, then upload the following documentation which will we use to carry out the DBS Check.
    There is no charge for this service.
  </p>

  
  <div v-if="!submitted">

    <div v-if="!hasPassedIdCheck" class="rounded-md bg-red-50 mb-4 p-4 max-w-prose">
      <div class="flex">
        <div class="flex-shrink-0">
          <ExclamationIcon class="h-5 w-5 text-red-400" aria-hidden="true" />
        </div>
        <div class="ml-3">
          <h3 class="text-sm font-medium text-red-800 m-0">
            You must complete our ID Check
          </h3>
          <div class="mt-1 text-sm text-red-700">
            <p class="mt-0 mb-3">
              As part of our safeguarding policy, tutors must first complete our ID Check before continuing with the DBS Check.
            </p>
            <TailwindButton @click="$router.push({ name: 'EditTutor-IdCheck' })">
              Complete ID Check
            </TailwindButton>
          </div>
        </div>
      </div>
    </div>

    <ul v-if="hasPassedIdCheck" role="list" class="space-y-4 sm:grid sm:grid-cols-2 sm:gap-6 sm:space-y-0 md:grid-cols-3">
      <UploadDocument
        :iconSrc="require('@/assets/FontAwesome/file-certificate-light.svg')"
        docType="certificate"
        :showValidationMessage="submitFailed && !certificateFileName"
        @uploaded="fileName => certificateFileName = fileName"
        @removed="() => certificateFileName = null"
      >
        <template #title>
          DBS Certificate
        </template>
        <template #description>
          A scan or high-quality photo of your Enhanced DBS certificate.
        </template>
      </UploadDocument>
    </ul>

    <div class="pt-6 flex flex-col justify-center items-center space-y-3 sm:items-start">
      <TailwindButton
        size="large"
        :loading="submitting"
        :disabled="!hasPassedIdCheck || submitting"
        @click="submit"
        class="w-full sm:w-auto"
      >
        Submit
      </TailwindButton>

      <p v-if="submitFailed" class="text-red-600 font-medium">
        Please upload all required files.
      </p>
    </div>

    <p class="mt-4 prose prose-sm prose-blue">If you have any queries or concerns, please don’t hesitate to get in touch with us at <a href="mailto:support@thetutorindex.com">support@thetutorindex.com</a> and we will be happy to assist.</p>
  </div>
  <div v-else class="rounded-md bg-green-50 p-4">
    <div class="flex">
      <div class="flex-shrink-0">
        <CheckCircleIcon class="h-5 w-5 text-green-400" aria-hidden="true" />
      </div>
      <div class="ml-3">
        <h3 class="text-sm font-semibold text-green-800">Thank you, your documentation has been submitted.</h3>
        <div class="mt-2 text-sm text-green-700 space-y-1">
          <p>We aim to review all submissions within 3-5 working days, after which we will let you know whether or not the DBS Check has been successful.</p>
          <p>If you have any questions, please feel free to contact us at <a href="mailto:support@thetutorindex.com" class="underline">support@thetutorindex.com</a>.</p>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import { ChevronLeftIcon, CheckCircleIcon } from '@vue-hero-icons/solid'
import TailwindButton from '../TailwindButton.vue'
import UploadDocument from './UploadDocument.vue'
import DbsService from '@/services/DbsServices.js'

const dbsService = new DbsService()

export default {
  components: {
    ChevronLeftIcon,
    TailwindButton,
    UploadDocument,
    CheckCircleIcon,
  },
  data() {
    return {
      certificateFileName: false,
      submitting: false,
      submitFailed: false,
      submitted: false,
    }
  },
  computed: {
    hasPassedIdCheck() {
      return this.$store.getters.user?.IdCheckStatus === 'verified'
    }
  },
  methods: {
    back() { this.$emit('back') },
    showRequirements() { this.$emit('showRequirements') },
    uploadFile: (type, file) => { 
      dbsService.uploadDocument(type, file)
    },
    async submit() {
      this.submitFailed = false

      if (!this.certificateFileName) {
        this.submitFailed = true
        return
      }

      try {
        this.submitting = true
        await dbsService.submit([this.certificateFileName])
      } finally {
        this.submitting = false
      }

      this.submitted = true
    },
  }
}
</script>

<style>

</style>